import React from 'react'
import { Station, translateStationStatus } from '../../types/stations.types'
import useSingleStation from '../../hooks/useSingleStation'
import { dateConverter } from '../../../../utils/dateConverter'
import SingleOrganization from '../../../organization/components/SingleOrganization'
import SingleHardware from '../../../hardwares/components/SingleHardware'
import { statusConverterStation } from '../StationList/StationList/StationListView/StationListView'
import useNavigationApp from '../../../../navigation/useNavigationApp'
import { limitString } from '../../../../utils/string.utils'

export interface StationInfoProps {
    info: keyof Station 
    stationId?: string
    styled?: boolean
    emptyText?: string,
    limitText?: number
    renderComponent?: (config:{labelRender: React.ReactNode, goTo: () => void}) => JSX.Element
}
export default function StationInfo({info, stationId, emptyText, styled, renderComponent, limitText}: StationInfoProps) {
    const {singleStationQuery:{isLoading, isError, data}} = useSingleStation(stationId)
    const navigationApp = useNavigationApp()

    if(isLoading) return <>...</>
    if(isError) return <>{emptyText? emptyText : ""}</>

    if (renderComponent && (info === "station_organization_id")) {
        return renderComponent({labelRender: (<SingleOrganization.Info info="organization_name" id={data?.station_organization_id}  limitText={limitText}/> ), goTo: () => navigationApp.goToSingleOrganization(data?.station_organization_id)})
    }

    if (info === "station_organization_id") {
        return <SingleOrganization.Info info="organization_name" id={data?.station_organization_id} limitText={limitText}/>
    }

    if (info === "station_hardware_id"){
        return <SingleHardware.Info info="hardware_device_id" id={data?.station_hardware_id}  limitText={limitText} />
    }

    if (info === "station_status" && styled && data?.station_status){
        return  statusConverterStation(data?.station_status)
    }

    const convertValue = (info: keyof Station, value: any) => {
        switch (info) {
            case "station_created_at":
                return dateConverter(value)
            case "station_updated_at":
                return dateConverter(value)
            case "station_status":
                return translateStationStatus(value)
            default:
                return value
        }
    }
  return (
    <>
      {limitString(convertValue(info, data?.[info]), limitText)}
    </>
  )
}
